const hideCommentPanel = () => {
  document.querySelector('.panelContainer').innerHTML = '';
};

export default hideCommentPanel;
